<!--
@Create By Tim For 19/08/21
@文档详情组件
-->

<template>
  <div class="DataInfo">
    <div class="title">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/DataList' }">课程资料库</el-breadcrumb-item>
        <el-breadcrumb-item>{{ data.docName }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 详情顶部 -->
    <div class="infoContent">
      <!-- 标题 -->
      <h1>
        <i class="el-icon-document"></i>
        {{ data.docName }}
        <span>上传时间：{{ data.createdTime }}</span>
      </h1>
      <!-- 分类 -->
      <p>所属分类：{{ data.categoryName }}</p>
      <!-- 简介 -->
      <div class="txt">简介：{{ data.docDescription }}</div>
      <!-- 下载次数 -->
      <div class="txt">
        下载次数：
        <span>{{ data.docDownloadVolume }}</span>
        次
        <span></span>
        人气：
        <span>{{ data.docPopularity }}</span>
        评论：
        <span>123</span>
        <!-- 下载按钮 -->
        <el-button @click="downloadData(data.id)" class="downloadBtn" type="primary" plain size="small">下载资料</el-button>
      </div>
    </div>

    <!-- 详情底部灰色区域 -->
    <div class="infoContentBottom">
      <!-- 标题 -->
      <h1>
        {{ data.docName }}
        <i class="el-icon-document"></i>
      </h1>

      <!-- 简介 -->
      <p>资料简介：{{ data.docDescription }}</p>

      <!-- 下载按钮 -->
      <p>
        <el-button @click="downloadData(data.id)" type="primary" plain style="margin-right: 16px;" size="small">下载资料</el-button>
        大小： {{ data.docSize }}kb
      </p>
      <!-- 下载说明 -->
      <p class="tips">下载说明：2015年服务进个课堂笔记的详细记载，和详细的分解。</p>
    </div>
  </div>
</template>

<script>
import api from '../../../config/api';
import { getToken } from 'chaos-sso-util';

export default {
  name: 'DataInfo',
  props: ['wordID', 'data'],
  data() {
    return {};
  },

  created() {},

  mounted() {},

  methods: {
    createObjectURL(object) {
      return window.URL ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object);
    },

    // 下载文档
    downloadData(id) {
      var self = this;
      var xhr = new XMLHttpRequest();
      var formData = new FormData();
      xhr.open('get', api + 'portal/doc/download?id=' + id); //url填写后台的接口地址，如果是post，在formData append参数（参考原文地址）
      xhr.setRequestHeader(process.env.VUE_APP_SSO_HEADER_TOKEN, getToken());
      xhr.responseType = 'blob';
      xhr.onload = function(e) {
        if (this.status == 200) {
          var blob = this.response;
          var filename = self.data.docName;
          // console.log(this.response)
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            var a = document.createElement('a');
            var url = self.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send(formData);
      //  if (window.sessionStorage.getItem('userInfo')) {
      // window.open(api + 'docs/download?id=' + id)
      //  } else {
      //    this.$message.error('请先登录再下载！')
      //  }
    }
  }
};
</script>

<style scoped>
.DataInfo {
  overflow: hidden;
}

.DataInfo .title {
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #000;
}

.DataInfo .infoContent {
  border-top: 1px solid #d3d3d3;
  padding-top: 15px;
}

.DataInfo .infoContent h1 {
  font-size: 16px;
  color: #2875bb;
  font-weight: normal;
}

.DataInfo .infoContent p {
  font-size: 14px;
  color: #333;
  margin-top: 22px;
}

.DataInfo .infoContent h1 span {
  font-size: 14px;
  color: #333;
  float: right;
  margin-top: 26px;
}

.DataInfo .infoContent .txt {
  font-size: 14px;
  color: #333;
  margin-top: 10px;
}

.DataInfo .infoContent .txt span:nth-child(1) {
  margin: 0;
}

.DataInfo .infoContent .txt span {
  color: #fc0101;
  margin-right: 30px;
}

.DataInfo .infoContent .txt .downloadBtn {
  float: right;
}

.DataInfo .infoContentBottom {
  background: #f4f4f4;
  border-radius: 2px;
  padding: 20px 30px;
  margin: 40px 0;
}

.DataInfo .infoContentBottom h1 {
  font-size: 18px;
  color: #333;
  font-family: PingFangSC-Medium;
  font-weight: 700;
}

.DataInfo .infoContentBottom p {
  font-size: 14px;
  color: #333;
  margin-top: 20px;
}

.DataInfo .infoContentBottom .tips {
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #333;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/DataInfo/DataInfo.vue